// extracted by mini-css-extract-plugin
export default {"container":"ContentPanel_container__pAk7P"};